<template>
        <v-card
            class="mx-auto contact-card"
        >
               <div class="">
                    <h2 class="home__headline-text primary--text">Have my say </h2>
                    <v-img width="60%" alt="Our words" contain class="welcome__logo" src="@/assets/nav_logo.png" />
                </div>

                <div class="introduction">
                    <transition name="slide-fade" mode="out-in">
                    <div :key="currentHello">
                        <h1>{{ currentHello }}</h1>
                        <h4></h4>
                    </div>
                    </transition>

                </div>
             <v-list>
                <transition name="slide-fade" mode="out-in">
                    <h4 :key="currentHello" class="select__title">{{select[0]}}</h4>
                </transition>

                <v-list-item-group
                    v-model="selectedLang"
                    item-value="code"
                    :items="langs"
                    mandatory
                    @change="updateLang(selectedLang)"
                    aria-label="Please select a language"
                >
                    <v-list-item
                    v-for="(item) in langs"
                    :key="item.code"
                    :value="item.code"

                    >

                    <v-list-item-content>
                        <v-list-item-title v-text="item.local_name !== '' ? item.name + ' | ' + item.local_name : item.name"></v-list-item-title>
                    </v-list-item-content>
                    </v-list-item>
                    <v-list-item class="d-none" value="na"></v-list-item>

                </v-list-item-group>
            </v-list>

        </v-card>
</template>

<script>
    // import hubbdata from "@/hubbdata";
    // import router from '../router/index.js'

export default {
    name: 'Settings',
    data() {
        return {
                selectedLang: 'na',
                langs: [
                    { 'name': 'English', 'code': 'en', 'local_name': '' },
                    { 'name': 'Albanian', 'code': 'sq', 'local_name': 'Shqiptare'},
                    { 'name': 'Amharic', 'code': 'am', 'local_name': 'አማርኛ'},
                    { 'name': 'Arabic', 'code': 'ar', 'local_name': 'عربي'},
                    { 'name': 'Bengali', 'code': 'bn', 'local_name': 'বাংলা'},
                    { 'name': 'Chinese', 'code': 'zh', 'local_name': '中国人'},
                    { 'name': 'French', 'code': 'fr', 'local_name': 'Français'},
                    { 'name': 'Hindi', 'code': 'hi', 'local_name': 'हिन्दी' },
                    { 'name': 'Korean', 'code': 'ko', 'local_name': '한국인'},
                    { 'name': 'Kurdish-Kurmanji', 'code': 'ku', 'local_name': 'Kurdî-Kurmancî'},
                    { 'name': 'Pashto', 'code': 'ps', 'local_name': 'میل' },
                    { 'name': 'Persian', 'code': 'fa', 'local_name': 'فارسی' },
                    { 'name': 'Polish', 'code': 'pl', 'local_name': 'Polski'},
                    { 'name': 'Portugese', 'code': 'pt', 'local_name': 'Português'},
                    { 'name': 'Russian', 'code': 'ru', 'local_name': 'Русский'},
                    { 'name': 'Somali', 'code': 'so', 'local_name': 'Soomaali'},
                    { 'name': 'Spanish', 'code': 'es', 'local_name': 'Español'},
                    { 'name': 'Turkish', 'code': 'tr', 'local_name': 'Türk'},
                    { 'name': 'Ukrainian', 'code': 'uk', 'local_name': 'український'},
                    { 'name': 'Vietnamese', 'code': 'vi', 'local_name': 'Tiếng Việt'}
                ],
                hello: ['Hello!', 'Bonjour!', 'Hola!', 'أهلا بك', '欢迎', 'Witamy!', 'Soo dhawow!', 'Chào mừng!' ],
                select: ['Please select a language', 'Veuillez sélectionner une langue', 'Por favor, seleccione un idioma', 'يرجى تحديد لغة', '请选择一种语言', 'Proszę wybierz język', 'Fadlan xulo luuqad', 'Vui lòng chọn một ngôn ngữ'],
                welcome: [
                    'Welcome to the Have My Say app',
                    "Bienvenue sur l'application Have My Say",
                    "Bienvenido a la aplicación Have My Say"
                 ],
                currentHello: 'Hello!'
        }
    },

    computed: {
        translations() {
            return this.$store.getters.translations;
        }
    },
    mounted(){
            localStorage.setItem('enable_font_change', false)
            window.setInterval(()=>{
            this.pollPerson();
            }, 5000);

     },
    methods: {

            updateLang(selectedLang) {
                this.$store.dispatch("updateLang", selectedLang).then(() => {
                  this.$store.dispatch("initDB").then(() => {
                    this.$router.push("/terms")
                });
              });
            },
            pollPerson(){
                const first = this.hello.shift();
                this.hello = this.hello.concat(first);
                this.currentHello = this.hello[0]
                const first2 = this.welcome.shift();
                this.welcome = this.welcome.concat(first2);
                const first3 = this.select.shift();
                this.select = this.select.concat(first3);
            },
            getText(item){
              `${item.name} - ${item.local_name}`
            }
    },
}
</script>


<style lang="scss" scoped>
    .contact-card {
        box-shadow: 0px 0px 0px 0px !important;
        padding-top: 20px;
        padding-bottom: 20px;
    }


    .introduction {
        padding: 2rem 1rem;
        font-size: 1rem;
        line-height: 1.6;
        text-align: center;
        transition: all 1s;


    }
    .select__title {
        text-align: center;
        margin-bottom: 20px;
    }
    .v-list {
        padding: 20px;
        padding-bottom: 0px;
    }
    .v-list-item {
        border-bottom: 1px solid grey;
    }
    .v-list-item:first-of-type {
        border-top: 1px solid grey;
    }

    .home__headline-text {
        text-align: center;
        padding: 50px 10px 0px 10px;
        font-size: 50px;
        line-height: 0px;
        margin-bottom: 30px;
      }

    .welcome__logo {
        height: 80px;
        margin: 0 auto;
    }

    .v-list-item--link:before {
        background-color: white !important;
    }

    p {
    font-size: 1.6rem;
    padding-left: 1rem;
    }
    .home__logo {
        text-align: center;
        margin-left: auto;
        margin-right: auto;
    }

  .slide-fade-enter-active {
  transition: all .8s ease;
}
.slide-fade-leave-active {
  transition: all .8s;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(0px);
  opacity: 0;
}
</style>
